(() => {
  const CHECKOUT_URL = '/checkout';

  const getVisibleAccordions = () =>
    Array.from(document.querySelectorAll('accordion-custom.accordion-nav'))
      .filter(acc => acc.offsetParent !== null);

  const getDetails = (acc) => acc?.querySelector('details');
  const getSummary = (acc) => acc?.querySelector('summary');

  // Ensure :focus-within before toggling so your CSS transitions stay enabled
  const toggleViaSummaryClick = (acc, shouldOpen) => {
    const details = getDetails(acc);
    const summary = getSummary(acc);
    if (!details || !summary) return false;

    if (details.open === shouldOpen) return true;

    // Put focus inside details first so :focus-within is true
    summary.focus({ preventScroll: true });

    // Trigger the same path as real user interaction
    summary.click();

    return true;
  };

  const hideButtonsEverywhere = (visible) => {
    visible.forEach(acc => {
      acc.querySelectorAll('.nav-btn').forEach(b => (b.hidden = true));
    });
  };

  const updateButtons = () => {
    const visible = getVisibleAccordions();
    const openAcc = visible.find(acc => getDetails(acc)?.open);

    // Hide everything first
    hideButtonsEverywhere(visible);
    if (!openAcc) return;

    const i = visible.indexOf(openAcc);
    const last = visible.length - 1;

    const prev = openAcc.querySelector('.nav-btn.prev');
    const next = openAcc.querySelector('.nav-btn.next');

    // PREV
    if (prev) {
        prev.hidden = (i === 0);
        prev.dataset.dir = '-1';
        prev.removeAttribute('data-checkout');
    }

    // NEXT / CHECKOUT  ⭐️ FIX IS HERE
    if (next) {
        next.hidden = false; // <-- ALWAYS unhide for active accordion

        if (i === last) {
        next.textContent = 'Checkout';
        next.dataset.checkout = 'true';
        next.removeAttribute('data-dir');
        } else {
        next.textContent = 'Next';
        next.dataset.dir = '1';
        next.removeAttribute('data-checkout');
        }
    }
    };

  const openRelative = (currentAcc, dir) => {
    const visible = getVisibleAccordions();
    const index = visible.indexOf(currentAcc);
    if (index === -1) return;

    const target = visible[index + dir];
    if (!target) return;

    // Close current, then open target on next frame(s) so transitions don’t get batched
    toggleViaSummaryClick(currentAcc, false);

    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        toggleViaSummaryClick(target, true);

        // Keep focus inside new accordion (no jump)
        requestAnimationFrame(() => {
          getSummary(target)?.focus({ preventScroll: true });
          updateButtons();
        });
      });
    });
  };

  // Initial button state
  updateButtons();

  /**
   * One CAPTURE listener:
   * - Handles nav clicks early
   * - Prevents auto-close-details.js (document bubble click) from running
   */
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('.nav-btn');
    if (!btn) return;

    const acc = btn.closest('accordion-custom');
    if (!acc || acc.offsetParent === null) return;

    // Stop the click from reaching summary default + document bubble handlers
    e.preventDefault();
    e.stopPropagation();

    // Checkout behavior
    if (btn.dataset.checkout === 'true') {
      window.location.href = CHECKOUT_URL;
      return;
    }

    const dir = parseInt(btn.dataset.dir, 10);
    if (!Number.isFinite(dir)) return;

    openRelative(acc, dir);
  }, true); // <-- capture

  // Keep buttons in sync when user clicks summary manually
  document.addEventListener('toggle', (e) => {
    if (e.target && e.target.tagName === 'DETAILS') updateButtons();
  }, true);

  // If accordions are hidden/shown dynamically
  const observer = new MutationObserver(updateButtons);
  observer.observe(document.body, {
    attributes: true,
    subtree: true,
    attributeFilter: ['style', 'class']
  });
})();
